import { render } from "./RetireePaymentsHistory.vue?vue&type=template&id=9df89e0e&ts=true"
import script from "./RetireePaymentsHistory.vue?vue&type=script&lang=ts"
export * from "./RetireePaymentsHistory.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__